import React from "react";
import { Modal, Spin } from "antd";
import { ProductOutlined } from "@ant-design/icons";

const LoadingModal = ({ visible, message = "Please Wait..." }) => {
    const customIcon = <ProductOutlined style={{ fontSize: '50px' }} spin />;

    return (
        <Modal
            open={visible}
            footer={null}
            closable={false}
            centered
            bodyStyle={{
            textAlign: "center",
            padding: "40px 20px",
            }}
        >
            <Spin indicator={customIcon} size="large"/>
            <p style={{ marginTop: 20, fontSize: "20px" }}>{message}</p>
        </Modal>
    );
};

export default LoadingModal;
